<template>
  <div class="container">
    <div class="wrapper">
      <div
        v-if="touchDisabled === 'false'"
        class="close"
        @click="$emit('close')"
      >
        <svg-icon :width="'16'" :height="'16'" icon="app-icons/close" />
      </div>
      <div class="tabs">
        <button
          class="tab"
          :class="{ selected: selectedTab === 'Assets' }"
          @click="selectedTab = 'Assets'"
        >
          My Images
        </button>
        <button
          class="tab"
          :class="{ selected: selectedTab === 'Icons' }"
          @click="selectedTab = 'Icons'"
        >
          Icon Library
        </button>
        <button
          v-if="embedVideo"
          class="tab"
          :class="{ selected: selectedTab === 'Embed' }"
          @click="selectedTab = 'Embed'"
        >
          Embed
        </button>
      </div>
      <asset-tab v-if="selectedTab === 'Assets'" v-bind="$props" />
      <icon-tab v-if="selectedTab === 'Icons'" v-bind="$props" />
      <embed-tab v-if="selectedTab === 'Embed'" v-bind="$props" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { supportsTouchEvents } from 'detect-it';
import AssetTab from './AssetTab.vue';
import IconTab from './IconTab.vue';
import SvgIcon from '../SvgIcon.vue';
import EmbedTab from './EmbedTab.vue';

export default {
  components: {
    'asset-tab': AssetTab,
    'icon-tab': IconTab,
    'embed-tab': EmbedTab,
    SvgIcon,
  },

  props: {
    // The current asset that is being replaced (optional)
    assetReference: {
      type: Object,
      default: null,
    },
    // A callback to use when the user selects an asset
    onSelect: {
      type: Function,
      default: () => {},
    },
    embedVideo: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      // The selected tab when the modal loads is the Assets tab
      selectedTab: 'Assets',
    };
  },

  computed: {
    touchDisabled() {
      return (!supportsTouchEvents).toString(); // data-simplebar-auto-hide expects string
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  width: 416px;
  max-width: 100%;
  background: #2c3233;
  color: #bcbcbc;
  max-height: 388px;
  border-radius: 10px;
  overflow: hidden;

  .wrapper {
    .close {
      position: absolute;
      top: 14px;
      right: 15px;
      cursor: pointer;
    }
    .tabs {
      display: flex;
      padding: 0 15px 0;
      border-bottom: 2px solid #314145;
      .tab {
        border: none;
        background: none;
        white-space: nowrap;
        min-width: 0px;
        flex-shrink: 0;
        border-bottom: 3px solid transparent;
        font-size: 14px;
        font-weight: 400;
        padding: 15px 0 10px;
        color: #808b8d;
        margin: 0 15px -2px 0;
        cursor: pointer;
        &:hover {
          color: #fff;
        }
        &.selected {
          border-bottom: 3px solid #db841e;
          color: #fff;
        }
      }
    }
  }

  .top {
    background: #303d40;
    border-radius: 10px 10px 0 0;
    padding: 20px;
    position: relative;
    display: flex;
    align-items: center;

    h2 {
      font-weight: 600;
      font-size: 18px;
      text-align: center;
      margin: 0;
      padding: 0;
      flex: 1;
    }

    .close {
      cursor: pointer;
    }
  }

  a {
    color: #db841e;
    text-decoration: none;
  }

  h1 {
    font-weight: 300;
    line-height: 1.5;
    text-align: center;
  }
}

.container p {
  font-size: 14px;
  line-height: 1.5;
}
</style>
